import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import {
  OFFERS,
  OFFER_CREATE,
  OFFER_VIEW,
  OFFER_EDIT,
  OFFER_NOTIFICATION_CREATE,
  OFFER_CARDS,
  OFFER_CARD_EDIT,
  OFFER_CARD_CREATE,
  OFFER_CARD_VIEW,
  AR_OFFERS_TYPE,
  OFFERS_TYPE,
} from '../../../constants/OfferConst';
import { selectedHotelSelector } from '../../property/propertySlice';
import { offerLoaderSelector, fetchAllOfferCards } from '../cmsSlice';
import OfferList from './offer-list/Offer-List';
import './Offer.scss';
import OfferCreate from './offer-create/Offer-Create';
import { Drawer } from '@material-ui/core';
import OfferNotificationCreate from './offer-create/Offer-Notification-Create';
import OfferView from './offer-view/Offer-View';
import { decryptLocalStorage, validateUserSession } from '../../../utils/authUtils';
import { useLocation } from 'react-router-dom';
import OfferCardsList from './offer-cards-list/Offer-Cards-List';
import OfferCardsCreate from './offer-cards-create/Offer-Cards-Create';
import OfferCardView from './offer-card-view/Offer-Card-View';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const Offers = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const classes = useStyles();
  const selectedHotel = useSelector(selectedHotelSelector);
  const offerLoader = useSelector(offerLoaderSelector);
  const history = useHistory();
  const [state, setState] = useState({
    type: OFFER_CREATE,
    status: false,
  });
  const [viewState, setViewState] = useState({
    type: OFFER_VIEW,
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const search = useLocation().search;
  const tabToOpen = new URLSearchParams(search).get('tab');
  const [activeTab, setActiveTab] = useState(tabToOpen || OFFERS);

  useEffect(() => {
    if (activeTab === OFFERS || activeTab === OFFER_CARDS) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    validateUserSession(history);
  }, [history]);

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const getOffersType = (typeId) => {
    const currentLang = decryptLocalStorage('lang') || 'en';
    const list = currentLang === 'ar' ? AR_OFFERS_TYPE : OFFERS_TYPE;

    if (typeId == null) {
      return list;
    }

    const match = list.find((item) => item.id === typeId);
    return match ? match.name : typeId;
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case OFFER_CREATE:
        return (
          <OfferCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            offerLoader={offerLoader}
            showLoader={showLoader}
            getOffersType={getOffersType}
          />
        );
      case OFFER_EDIT:
        return (
          <OfferCreate
            toggleDrawer={onDrawerToggle}
            offerItem={state.obj}
            hotelId={selectedHotel}
            offerLoader={offerLoader}
            showLoader={showLoader}
            getOffersType={getOffersType}
          />
        );
      case OFFER_CARD_CREATE:
        return (
          <OfferCardsCreate
            toggleDrawer={onDrawerToggle}
            offerItem={state.obj}
            hotelId={selectedHotel}
            offerLoader={offerLoader}
            showLoader={showLoader}
          />
        );
      case OFFER_CARD_EDIT:
        return (
          <OfferCardsCreate
            toggleDrawer={onDrawerToggle}
            offerItem={state.obj}
            hotelId={selectedHotel}
            offerLoader={offerLoader}
            showLoader={showLoader}
          />
        );
      case OFFER_NOTIFICATION_CREATE:
        return (
          <OfferNotificationCreate
            toggleDrawer={onDrawerToggle}
            offerItem={state.obj}
            hotelId={selectedHotel}
            offerLoader={offerLoader}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case OFFER_VIEW:
        return (
          <OfferView
            permissions={permissions}
            offer={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            getOffersType={getOffersType}
          />
        );
      case OFFER_CARD_VIEW:
        return (
          <OfferCardView
            permissions={permissions}
            offer={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status ? (
        <>{switchViewContent(viewState)}</>
      ) : (
        <>
          <div className='container mt-4'>
            <div className='row d-flex'>
              <div className='col-md-6'>
                <span className='page-title'>Offers</span>
              </div>
              <div className='col-md-6 d-flex justify-content-end'></div>
            </div>
            <div className='row d-flex mt-4 accommodation-list'>
              <div className='d-flex flex-wrap'>
                <Button
                  size='large'
                  variant={activeTab === OFFERS ? 'outlined' : 'text'}
                  className={
                    activeTab === OFFERS ? classes.activeButton : classes.button + 'showpopup'
                  }
                  onClick={() => setActiveTab(OFFERS)}
                >
                  Offers
                </Button>
                <Button
                  size='large'
                  variant={activeTab === OFFER_CARDS ? 'outlined' : 'text'}
                  className={
                    activeTab === OFFER_CARDS ? classes.activeButton : classes.button + 'showpopup'
                  }
                  onClick={() => setActiveTab(OFFER_CARDS)}
                >
                  Offer Cards
                </Button>
              </div>
            </div>
            <div className='row mx-2 d-flex mt-4'>
              <div className='card shadow'>
                {activeTab === OFFERS && (
                  <OfferList
                    onDrawerToggle={onDrawerToggle}
                    onViewToggle={onViewToggle}
                    hotelId={selectedHotel}
                    offerLoader={offerLoader}
                    permissions={permissions}
                    onsetPage={(e) => setPage(e)}
                    page={page}
                    onsetRowsPerPage={(e) => setRowsPerPage(e)}
                    rowsPerPage={rowsPerPage}
                    getOffersType={getOffersType}
                  />
                )}
                {activeTab === OFFER_CARDS && (
                  <OfferCardsList
                    onDrawerToggle={onDrawerToggle}
                    onViewToggle={onViewToggle}
                    hotelId={selectedHotel}
                    offerLoader={offerLoader}
                    permissions={permissions}
                    onsetPage={(e) => setPage(e)}
                    page={page}
                    onsetRowsPerPage={(e) => setRowsPerPage(e)}
                    rowsPerPage={rowsPerPage}
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Offers;
